module.exports = __webpack_public_path__ + "img/double-arrow-down.7a2172ac.svg";